export class CargoEventLog {
  static DateTimeFormat: string = "YYYY-MM-DD HH:mm";

  id: number = 0;
  suntekID: string = '';
  mblNo: string = '';
  cntrId: string = '';
  cntrNo: string = '';
  srcEventId: string = '';
  srcEventType: string = '';
  eventName: string = '';
  locCode: string = '';
  locName: string = '';
  utcTime: string | null = null;
  timezone: string  = '';
  locTime: string| null = null;
  curValue: string | null = null;
  isAir: boolean = false;
  u1Id: string = '';
  u1Date: string | null = null;

  constructor(evtName: string, curValue: string | null = null) {
    if (evtName) {
      this.eventName = evtName;
    }
    if (curValue !== null) {
      this.curValue = curValue;
    }
  }
}